<mat-card class="cardWithShadow" [ngClass]="{ 'oculto': dataSource.data.length == 0 }">
    <h3>Cesionarios</h3>
    <mat-card-content class="p-24 table-responsive">

        <table mat-table [dataSource]="dataSource"
        matSort (matSortChange)="changeSortTable($event)">
            <ng-container matColumnDef="CesionarioRut">
                <th class="th-header" mat-header-cell mat-sort-header *matHeaderCellDef>
                    Rut
                </th>
                <td mat-cell *matCellDef="let element">
                    <h6>{{ element.cesionarioRut}}</h6>
                </td>
            </ng-container>

            <ng-container matColumnDef="CesionarioName">
                <th class="th-header" mat-header-cell mat-sort-header *matHeaderCellDef>
                    Nombre
                </th>
                <td mat-cell *matCellDef="let element">
                    <h6>
                        <a [routerLink]="['/dashboards/factoring', element.cesionarioCompanyId]">{{ element.cesionarioName }}</a>
                    </h6>
                </td>
            </ng-container>

            <ng-container matColumnDef="TotalAmountTransferInvoices">
                <th class="th-header" mat-header-cell mat-sort-header *matHeaderCellDef>
                    Monto Total 
                </th>
                <td mat-cell *matCellDef="let element">
                    <h6>{{ element.totalAmountTransferInvoices | currency: 'CLP' }}</h6>
                </td>
            </ng-container>

            <ng-container matColumnDef="NumTransferInvoices">
                <th class="th-header" mat-header-cell mat-sort-header *matHeaderCellDef>
                    Facturas cedidas 
                </th>
                <td mat-cell *matCellDef="let element">
                    <h6>{{ element.numTransferInvoices }}</h6>
                </td>
            </ng-container>

            <ng-container matColumnDef="MedianTotalAmountTransferInvoices">
                <th class="th-header" mat-header-cell *matHeaderCellDef>
                    Mediana Monto Total
                </th>
                <td mat-cell *matCellDef="let element">
                    <h6>{{ element.medianTotalAmountTransferInvoices | currency: 'CLP' }}</h6>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columns"></tr>
            <tr mat-row *matRowDef="let row; columns: columns"></tr>
        </table>
        <mat-paginator
        [pageSizeOptions]="[10, 25, 50, 100]"
        (page)="changePaginationTable($event)"></mat-paginator>
    </mat-card-content>
</mat-card>